import { convertGetManyResponse } from '@app/core/crud/response-converter';
import { ListViewInfinite } from '@app/core/list-view/ListViewInfinite';
import { ListViewQueryParams } from '@app/core/list-view/types';
import { EnrichedCompositionListItemDto } from '@app/modules/compose/composition.types';
import { Station } from '@app/core/types/stations';
import { webAppListCompositions } from '@mi-front/api-v2';
import { Paginated, cleanQuery } from '@mi-front/core';
import { CompositionsGrid } from './compositions-grid/CompositionsGrid';
import { CreateCompositionButton } from './CreateCompositionButton';
import { CompositionsListEmptyState } from './compositions-list-empty-state/CompositionsListEmptyState';
import { COMPOSE_FILTERS_CONFIG } from './filters/compose-filters-config';

/**
 * Station-scoped compositions list using BFF pagination (`page`, `limit`, optional `start`/`end`).
 */
export function ComposeList({ station }: { station: Station }) {
  const listId = `compose-compositions-list-${station.slug}`;

  const queryFn = async (
    params: ListViewQueryParams,
  ): Promise<Paginated<EnrichedCompositionListItemDto>> => {
    const response = await webAppListCompositions(
      cleanQuery({
        stationId: station.id,
        limit: params.pageSize,
        page: params.pageIndex + 1,
        ...params,
      }),
    );

    return await convertGetManyResponse(response);
  };

  return (
    <ListViewInfinite
      listId={listId}
      filters={COMPOSE_FILTERS_CONFIG}
      queryFn={queryFn}
      actions={[<CreateCompositionButton key="create-composition" stationSlug={station.slug} />]}
      ListComponent={CompositionsGrid}
      renderEmptyState={() => <CompositionsListEmptyState stationSlug={station.slug} />}
      showProgress
      maxPages={3}
    />
  );
}
